import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { s3LoadUrl } from '../../helper/s3LoadUrl';

import Title from '../../components/Title';
import Button from '../../components/Button';
import Accordion from '../../components/Accordion';
import { Pluss } from '../../static';

import './styles.scss';

const VirusDetails = ({virus, id}) => {
	let bgUrl ='';

	if(virus && virus.backgroundImage) {
		bgUrl = s3LoadUrl(virus.backgroundImage);
	};
	
	return (
		<div className="virus-wrapper">
		{
			virus && (
				<div className="virus">
					<header className="virus__header">
						<div className="virus__bg">
							<img src={bgUrl} alt="backgrund_virus"/>
						</div>
						<Title text={virus.name} isExtra isWhite/>
						<div className="virus__header-btn">
							<Link to={`/virus/${id}/add-virus`}>
								<Button 
									text='Add Patient' 
									type='button' 
									leftIcon={<Pluss />} 
									isLight
								/>
							</Link>
						</div>
					</header>
					<div className="container">
						<section className="virus__content">
							<Accordion data={virus.info} />
						</section>
					</div>
				</div>
			)
		}
		</div>
	);
};



const mapStateToProps = (state, ownProps) => {
	const id = ownProps.match.params.id;
	
	const availableViruses = state.firestore.data.available_viruses
	const virus = availableViruses ? availableViruses[id] : null

	return {
		virus,
		id
	}
}

export default connect(mapStateToProps)(VirusDetails);


// const details = [
//     {
//         title: "What is COVID-19?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
//     {
//         title: "What are the symptoms?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",

//     },
//     {
//         title: "How does it spread?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",

//     },
//     {
//         title: "Can the virus that causes COVID-19 be spread through food, including restaurant take out, refrigerated or frozen packaged food?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",

//     },
//     {
//         title: "Will warm weather stop the outbreak of COVID-19?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",

//     },
//     {
//         title: "Can mosquitoes or ticks spread the virus that causes COVID-19?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
//     {
//         title: "How can I protect myself?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
//     {
//         title: "Does CDC recommend the use of facemask or face coverings to prevent COVID-19?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
//     {
//         title: "Is it safe to get care for my other medical conditions during this time?",
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
//     {
//         title: "Is it safe to get care for my other medical conditions during this time?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
//     {
//         title: "Is it safe to get care for my other medical conditions during this time?", 
//         content:"Coronavirus (COVID-19) is an illness caused by a virus that can spread from person to person. The virus that causes COVID-19 is a new coronavirus that has spread throughout the world. COVID-19 symptoms can range from mild (or no symptoms) to severe illness.",
//     },
// ];